<div class="header" i18n>Versionsverlauf</div>
<mat-divider></mat-divider>

@if (projectData$ | async; as data) {
  @if (data.project.info.loadedHistoryEntry != null) {
    <div class="old-version-warning">
      <div class="icon-wrapper">
        <mat-icon>warning</mat-icon>
        <div i18n
          >Du hast eine Sicherung geladen. Um zu speichern, musst Du sie entweder wiederherstellen oder zur neuesten Version
          zurückwechseln.</div
        >
      </div>
      <button
        mat-button
        color="warn"
        (click)="restoreBackup()"
        [dtOverlayProgress]="isRestoringBackup"
        [disabled]="isRestoringBackup"
        data-cy="restore-project-button"
        i18n
        >Wiederherstellen</button
      >
      <button mat-button [disabled]="isRestoringBackup" (click)="onClick(data.project.info.id)" data-cy="revert-to-newest-button" i18n
        >Zur neuesten Version wechseln</button
      >
    </div>
    <mat-divider></mat-divider>
  }
  <div class="history-list" data-cy="project-history-list">
    <button matRipple (click)="onClick(data.project.info.id)">
      <span class="date">{{ data.project.info.updatedAt | date: 'medium' }}</span>
      &nbsp;—&nbsp;
      <span class="type-description" i18n>Neueste Version</span>
      @if (data.project.info.loadedHistoryEntry == null) {
        <div class="active-indicator"></div>
      }
    </button>
    @for (group of data.groupedVersions; track group) {
      @if (group.length > 1) {
        <button matRipple (click)="toggleGroup(group.at(-1).id)">
          <span class="date">{{ group.at(-1).versionTimestamp | date: 'medium' }}</span
          >&nbsp;<mat-icon>{{ expandedGroupIds.has(group.at(-1).id) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      }
      @if (group.length === 1 || expandedGroupIds.has(group.at(-1).id)) {
        @for (entry of group; track entry) {
          <button matRipple (click)="onClick(data.project.info.id, entry.id)" [class.grouped-item]="group.length > 1">
            <span class="date">{{ entry.versionTimestamp | date: (group.length === 1 ? 'medium' : 'mediumTime') }}</span>
            &nbsp;—&nbsp;
            <span class="type-description">
              @switch (entry.saveType) {
                @case ('save-as') {
                  <ng-container i18n>Speichern unter</ng-container>
                }
                @case ('restore-backup') {
                  <ng-container i18n>Wiederhergestellt</ng-container>
                }
                @case ('resolve-conflict') {
                  <ng-container i18n>Versionskonflikt</ng-container>
                }
                @default {
                  <ng-container i18n>Sicherung</ng-container>
                }
              }
            </span>
            @switch (entry.saveType) {
              @case ('save-as') {
                <mat-icon>save_as</mat-icon>
              }
              @case ('restore-backup') {
                <mat-icon>settings_backup_restore</mat-icon>
              }
              @case ('resolve-conflict') {
                <mat-icon>merge</mat-icon>
              }
            }
            @if (data.project.info.loadedHistoryEntry === entry.id) {
              <div class="active-indicator"></div>
            }
          </button>
        }
      }
    }
  </div>
} @else {
  @if (hasError) {
    <mat-error class="dt-error" i18n>Beim Laden der Historie ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</mat-error>
  } @else {
    <mat-spinner></mat-spinner>
  }
}
